import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector, useStore } from 'react-redux';
import _ from 'lodash';

import { API_URLS } from '../constants/apiUrls';
import { post } from '../utils/baseFetch';
import { mergeQueueConfig } from '../utils/queueUtils';
import { setQueueConfig, setRequestParams } from '../reducers/queueSlice';
import { getAvaliableSectionList } from '../utils/queueUtils';
import { getStringByTheme } from '../utils/utils';
import { QUEUE_STEPS } from '../constants/constants';
import { PATH } from '../constants/paths';

import { SiteInfo } from '../components/SiteInfo';
import { GuluLogo } from '../components/GuluLogo';
import { QueueBottomBtn } from '../components/QueueBottomBtn';
import { QueueTitle } from '../components/QueueTitle';

import { ReactComponent as ServiceTypeIcon } from '../images/service-type.svg';

import '../styles/queue-service-type.scss';

const QueueServiceType = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const store = useStore();

  const queueConfig = useSelector((state) => state.queue.queueConfig);
  const requestParams = useSelector((state) => state.queue.requestParams);
  const token = useSelector((state) => state.system.token);
  const lang = useSelector((state) => state.system.lang);
  const theme = useSelector((state) => state.system.theme);

  const [serviceTypeList, setServiceTypeList] = useState([]);

  useEffect(() => {
    document.title = getStringByTheme('queueServiceType', lang, theme);
  }, [lang]);

  useEffect(() => {
    if (!queueConfig || (requestParams.selectedDate && !queueConfig.filterResult)) {
      const newParams = _.cloneDeep(requestParams);
      newParams.siteId = params.siteId;
      post(API_URLS.QUEUE, newParams, (payload) => {
        const newConfig = mergeQueueConfig(queueConfig, payload);
        dispatch(setQueueConfig(newConfig));
      }, undefined, store);
    }
  }, [params.siteId, dispatch, store, queueConfig]);

  useEffect(() => {
    if (queueConfig && queueConfig.filterResult) {
      const avaliableSectionList = getAvaliableSectionList(queueConfig.steps, QUEUE_STEPS.TABLE_TYPE, requestParams, queueConfig.filterResult);
      const tempMap = new Map();
      avaliableSectionList.forEach((section) => {
        if (!tempMap.has(section.tableType)) {
          tempMap.set(section.tableType, {
            tableType: section.tableType,
            tableTypeLabel: section.tableTypeLabel
          });
        }
      });
      setServiceTypeList(Array.from(tempMap.values()).sort((a, b) => { return a.tableType.localeCompare(b.tableType) }));
    }
  }, [queueConfig, requestParams])

  function handleServiceTypeChange(serviceType) {
    const newParams = _.cloneDeep(requestParams);
    newParams.tableType = serviceType.tableType;
    dispatch(setRequestParams(newParams));
  }

  function handleSiteDetailButtonClick() {
    history.push(PATH.SITE_DETAIL + params.siteId);
  }

  return (
    <>
      {
        queueConfig &&
        <>
          <div className="queue-wrapper">
            <GuluLogo show={!token && queueConfig.siteInfo && queueConfig.siteInfo.showIcon} />
            <div className="background-site-info"><SiteInfo site={queueConfig && queueConfig.siteInfo} show={false} showLang={false} /></div>
            <div className="queue-wrapper-content queue-service-type-wrapper">
              <QueueTitle title={getStringByTheme('selectServiceType', lang, theme)} />
              {
                serviceTypeList.map((serviceType, index) => {
                  return <div className="service-type-radio-wrapper" key={index}>
                    <input
                      type="radio"
                      id={serviceType.tableType}
                      name="serviceType"
                      checked={serviceType.tableType === requestParams.tableType}
                      onChange={() => handleServiceTypeChange(serviceType)}
                    />
                    <ServiceTypeIcon className='image' />
                    <label htmlFor={serviceType.tableType}>{serviceType.tableTypeLabel}</label>
                  </div>
                })
              }
            </div>
          </div>
          <QueueBottomBtn currentStep={QUEUE_STEPS.TABLE_TYPE} />
        </>
      }
      {
        !queueConfig &&
        <div className="queue-single-button-wrapper">
          <div className="single-button" onClick={handleSiteDetailButtonClick}>{getStringByTheme('returnToSiteDetail', lang, theme)}</div>
        </div>
      }
    </>
  );
}

export default QueueServiceType;
